
import React, { useState } from 'react';
import './App.css';
import CoralFractal from './CoralFractal';
import SnowflakeFractal from './SnowflakeFractal';
import SierpinskiTriangle from './SierpinskiTriangle';
import RomanescoBroccoli from './RomanescoBroccoli';
import CantorSet from './CantorSet';
import MandelbrotSet from './MandelbrotSet';
import LightningFractal from './LightningFractal';
import LightningTreeFractal from './LightningTreeFractal';

function App() {
  const [currentFractal, setCurrentFractal] = useState('coral');
  
  return (
    <div className="App">
      <header className="App-header">
        <h1>프랙탈 시뮬레이션</h1>
        <div className="fractal-selector">
          <button 
            className={`selector-btn ${currentFractal === 'coral' ? 'active' : ''}`}
            onClick={() => setCurrentFractal('coral')}
          >
            산호 프랙탈
          </button>
          <button 
            className={`selector-btn ${currentFractal === 'snowflake' ? 'active' : ''}`}
            onClick={() => setCurrentFractal('snowflake')}
          >
            눈꽃송이 프랙탈
          </button>
          <button 
            className={`selector-btn ${currentFractal === 'sierpinski' ? 'active' : ''}`}
            onClick={() => setCurrentFractal('sierpinski')}
          >
            시에르핀스키 삼각형
          </button>
          <button 
            className={`selector-btn ${currentFractal === 'romanesco' ? 'active' : ''}`}
            onClick={() => setCurrentFractal('romanesco')}
          >
            로마네스코 브로콜리
          </button>
          <button 
            className={`selector-btn ${currentFractal === 'cantor' ? 'active' : ''}`}
            onClick={() => setCurrentFractal('cantor')}
          >
            칸토어 집합
          </button>
          <button 
            className={`selector-btn ${currentFractal === 'mandelbrot' ? 'active' : ''}`}
            onClick={() => setCurrentFractal('mandelbrot')}
          >
            망델브로 집합
          </button>
          <button 
            className={`selector-btn ${currentFractal === 'lightning' ? 'active' : ''}`}
            onClick={() => setCurrentFractal('lightning')}
          >
            번개 폭풍
          </button>
          <button 
            className={`selector-btn ${currentFractal === 'lightningtree' ? 'active' : ''}`}
            onClick={() => setCurrentFractal('lightningtree')}
          >
            번개 가지
          </button>
        </div>
        <p>
          {currentFractal === 'coral' 
            ? '파티클이 확산되어 구조물에 붙어 성장하는 프랙탈입니다.'
            : currentFractal === 'snowflake'
            ? '하늘에서 떨어지는 눈꽃송이 패턴을 형성하는 프랙탈입니다.'
            : currentFractal === 'sierpinski'
            ? '삼각형을 재귀적으로 분할하여 생성하는 자기 유사 프랙탈입니다.'
            : currentFractal === 'romanesco'
            ? '자연계에서 발견되는 피보나치 나선 구조를 가진 프랙탈입니다.'
            : currentFractal === 'cantor'
            ? '구간을 반복적으로 3등분하여 중간 부분을 제거하는 프랙탈입니다.'
            : currentFractal === 'mandelbrot'
            ? '복소평면에서 z²+c가 발산하지 않는 점들의 집합으로 만들어진 프랙탈입니다.'
            : currentFractal === 'lightning'
            ? '랜덤한 분기와 지그재그 패턴으로 자연스러운 번개를 시뮬레이션하는 프랙탈입니다.'
            : '중앙에서 방사형으로 번개가 가지를 뻗어나가는 프랙탈입니다.'}
        </p>
      </header>
      <main className="App-content">
        {currentFractal === 'coral' 
          ? <CoralFractal /> 
          : currentFractal === 'snowflake'
          ? <SnowflakeFractal />
          : currentFractal === 'sierpinski'
          ? <SierpinskiTriangle />
          : currentFractal === 'romanesco'
          ? <RomanescoBroccoli />
          : currentFractal === 'cantor'
          ? <CantorSet />
          : currentFractal === 'mandelbrot'
          ? <MandelbrotSet />
          : currentFractal === 'lightning'
          ? <LightningFractal />
          : <LightningTreeFractal />}
      </main>
      <footer className="App-footer">
        <p>프랙탈 기하학 시각화</p>
      </footer>
    </div>
  );
}

export default App; 